export const news = [
  {
    id: "n1",
    title: "《美国禁忌4》最终季正式定档，主创确认“不拍续集”",
    category: "官方动态",
    date: "2025-08-12",
    author: "本站编译",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20premiere%20red%20carpet%20with%20dramatic%20spotlights%20and%20dark%20elegant%20atmosphere%2C%20deep%20blue%20and%20amber%20tones%2C%20entertainment%20news%20mood%20widescreen&width=800&height=450&seq=news-n1-v1&orientation=landscape",
    summary:
      "官方宣布最终季将于九月五日首播，并明确全五集将完整收束主线，不会以任何形式开发衍生或续订。",
    content: [
      "备受关注的《美国禁忌4》终于敲定最终季播出档期。官方在凌晨发布的短片中确认，全季共五集，将于九月五日一次性进入播出周期，并在十月三日迎来大结局。",
      "更让剧迷意外的是，主创在短片中直接回应了外界关于“衍生剧”的猜测：这个故事会在这里完整结束，不会有续集、前传或衍生作品。",
      "主创在配文中写道：“我们花了四年时间，只为了把这最后一封信写完。”这句话也被大量剧迷引用，成为定档消息下最热门的评论。",
      "从已公布的预告节奏来看，最终季将延续前三季克制的镜头语言，但会明显提高信息密度，把此前埋下的所有伏笔依次收拢。",
    ],
    tags: ["定档", "最终季", "官方"],
  },
  {
    id: "n2",
    title: "深度解析：为什么“三天空白”是全剧最关键的结构支点",
    category: "深度解析",
    date: "2025-04-10",
    author: "剧评人 · 陈默",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20wall%20covered%20in%20red%20strings%20connecting%20photos%20and%20notes%2C%20moody%20dark%20blue%20with%20amber%20lamp%20light%2C%20detective%20investigation%20aesthetic%20widescreen&width=800&height=450&seq=news-n2-v1&orientation=landscape",
    summary:
      "第三季抛出的“三天空白”并不只是悬念，它是全剧用来讨论“记忆可以被抹去吗”的核心装置。",
    content: [
      "如果把《美国禁忌4》的四季看作一封信，那么第三季第二集出现的“三天空白”，就是这封信里被涂掉、却又最显眼的那一行。",
      "从结构上看，编剧非常聪明地选择了一个“无法被证明”的时间段：所有物证被清理，所有证词相互矛盾，唯一剩下的是一支没拧紧的口红。这种留白逼着观众和角色一起去“假设”，而不是被动接收答案。",
      "这也解释了为什么莉娜的数据线与苏菲的病历线会在这一集重合——它们代表两种不同性质的记忆：一种可以被备份，一种只能存在于人脑里。",
      "当两种记忆指向同一个空白时，真相就不再是一个点，而是一段被集体默认忽略的区间。这，正是全剧最锋利的地方。",
    ],
    tags: ["深度解析", "第三季", "结构"],
  },
  {
    id: "n3",
    title: "专访主演玛格丽特·斯隆：艾琳的告别比我想象中更难",
    category: "采访",
    date: "2025-09-20",
    author: "本站特约",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20woman%20giving%20an%20interview%20in%20a%20dim%20elegant%20room%20with%20amber%20practical%20lights%2C%20deep%20blue%20shadows%2C%20editorial%20portrait%20widescreen&width=800&height=450&seq=news-n3-v1&orientation=landscape",
    summary:
      "在最终季专访中，玛格丽特·斯隆分享了如何为一个“从不哭出声”的角色设计情绪，以及她最难拍的一场戏。",
    content: [
      "“艾琳不会哭出声，她只会把肩膀绷得更紧一点。”谈起这个陪伴自己四年的角色，玛格丽特·斯隆用了这样一个细节。",
      "她坦言，最难的一场戏并不是码头对峙，也不是医院走廊，而是最终季里那个安静的清晨——“当你知道一切都结束了，却还要继续往前走的时候，那种空，比任何嘶吼都难演。”",
      "谈到与大卫的对手戏，她表示两人几乎不用沟通就能达成默契：“我们把所有的台词都演在停顿里。”",
      "对于是否希望有续集，她笑着摇头：“有些故事的完整，恰恰来自它的结束。”",
    ],
    tags: ["采访", "主演", "最终季"],
  },
  {
    id: "n4",
    title: "花絮：码头对峙戏其实拍了整整两天，只为等一场真正的雾",
    category: "花絮",
    date: "2025-09-15",
    author: "幕后小组",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20behind%20the%20scenes%20film%20set%20at%20a%20harbor%20at%20dusk%20with%20crew%20and%20camera%20equipment%20in%20fog%2C%20moody%20blue%20and%20amber%20tones%2C%20documentary%20mood%20widescreen&width=800&height=450&seq=news-n4-v1&orientation=landscape",
    summary:
      "第二季季终的码头对峙被剧迷称为“全剧最安静的高潮”，而这背后是一场对自然光的漫长等待。",
    content: [
      "剧组在拍摄那个著名的码头对峙时，并没有使用任何造雾设备。导演坚持要用真实的夜雾，因为他觉得“机器造的雾太整齐了”。",
      "于是整个团队在码头等了整整两天，只在第三天的凌晨等到了理想的那一层薄雾。",
      "更有意思的是，这场戏原本有大量台词，最终被导演一减再减，只有一句保留了下来——“你以为你在查案，其实你在选阵营。”",
      "摄影指导透露，为了让水面反光保持稳定，他们甚至在镜头外压了很重的东西固定浮台，这段幕后片段在花絮特辑放出后迅速走红。",
    ],
    tags: ["花絮", "幕后", "拍摄"],
  },
  {
    id: "n5",
    title: "周边与设定集同步公布，官方将推出四季角色档案合集",
    category: "官方动态",
    date: "2025-08-28",
    author: "本站编译",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20an%20elegant%20hardcover%20art%20book%20on%20a%20dark%20table%20with%20amber%20lighting%20and%20blue%20shadows%2C%20premium%20merchandise%20mood%20widescreen&width=800&height=450&seq=news-n5-v1&orientation=landscape",
    summary:
      "官方确认将随最终季推出《美国禁忌4：角色档案》设定集，收录四季节点的角色关系图与创作手记。",
    content: [
      "随着最终季临近，官方公布了一系列配套内容计划，其中《美国禁忌4：角色档案》设定集最受关注。",
      "据官方介绍，设定集将按季节梳理主要角色的登场与转变，并首次公开完整的角色关系图谱与主创批注。",
      "此外，书中还会收录多张未被采用的分镜手稿，其中包含一个被删掉的早期结局版本。",
      "官方强调，所有内容均围绕剧集本身，不会涉及任何播放或线上观影服务，仅作为剧迷的收藏与阅读资料。",
    ],
    tags: ["官方动态", "设定集", "周边"],
  },
  {
    id: "n6",
    title: "角色解读：维多利亚·斯特恩为什么是近年最难写的反派之一",
    category: "深度解析",
    date: "2025-03-30",
    author: "剧评人 · 林川",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20an%20empty%20elegant%20office%20with%20a%20single%20leather%20chair%20and%20cold%20window%20light%2C%20deep%20blue%20and%20amber%20tones%2C%20power%20drama%20mood%20widescreen&width=800&height=450&seq=news-n6-v1&orientation=landscape",
    summary:
      "她从不咆哮、从不失态，却让所有人不敢打断——维多利亚的反派魅力，来自一种被克制到极致的权力。",
    content: [
      "写一个“坏得很吵”的反派并不难，难的是写一个人物，她的每一次客气都让人后背发凉。维多利亚·斯特恩正是后者。",
      "编剧对这个角色的处理有一条不成文的原则：她永远比对手多说一句，也永远比对手多等一步。耐心，就是她的武器。",
      "更值得玩味的是她的动机。她并不认为自己在作恶，她相信自己在维持秩序。这种“自洽的恶”，让她远比脸谱化的反派更令人不安。",
      "也正因如此，最终季中伊莎贝尔的出现才格外有意义——当旧的秩序被更激进的人取代，维多利亚才第一次尝到了“被超越”的滋味。",
    ],
    tags: ["角色解读", "反派", "深度"],
  },
  {
    id: "n7",
    title: "第三季收视与口碑双升，剧迷社群单集讨论量创新高",
    category: "剧集新闻",
    date: "2025-04-06",
    author: "本站编译",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20glowing%20data%20charts%20and%20analytics%20screens%20in%20a%20dark%20room%2C%20cool%20blue%20with%20warm%20amber%20accents%2C%20modern%20media%20mood%20widescreen&width=800&height=450&seq=news-n7-v1&orientation=landscape",
    summary:
      "第三季季终播出后，剧集讨论度明显攀升，多个平台的单集讨论量创下开播以来新高。",
    content: [
      "随着第三季季终集的播出，《美国禁忌4》在多个剧迷社群的讨论量迎来明显增长。",
      "观众讨论的焦点集中在诺亚的抉择上：有人认为那是一次悲剧性的必然，也有人觉得编剧“下手太狠”。",
      "值得注意的是，围绕“三天空白”的分析长文成为本季传播度最高的内容类型，显示出该剧观众对结构解读的强烈兴趣。",
      "行业观察者认为，这种“慢热但黏性极高”的观众结构，正是该剧能够走完四季的重要原因。",
    ],
    tags: ["剧集新闻", "收视", "口碑"],
  },
  {
    id: "n8",
    title: "花絮：那些被删掉的台词，其实藏着角色真正的动机",
    category: "花絮",
    date: "2025-02-18",
    author: "幕后小组",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20marked%20up%20screenplay%20script%20with%20coffee%20stains%20on%20a%20dark%20table%2C%20amber%20desk%20lamp%20and%20blue%20shadows%2C%20intimate%20creative%20mood%20widescreen&width=800&height=450&seq=news-n8-v1&orientation=landscape",
    summary:
      "主创公开了一批删减片段，其中不少台词恰恰解释了角色“为什么这么做”，也让一些争议情节有了新解读。",
    content: [
      "在最新放出的删减片段中，最引发讨论的是大卫的一段独白。这段台词解释了他在第一季为何草草结案，而它最终因为“说得太明白”被删掉。",
      "主创解释：“我们宁愿观众去猜，也不愿把答案塞给他们。角色的魅力在于他们不完全透明。”",
      "另一段被删的戏属于维多利亚，她在其中第一次流露出疲惫。主创认为保留这种疲惫会削弱她的压迫感，于是选择舍弃。",
      "这些删减内容目前已被整理进设定集，成为理解角色的补充材料。",
    ],
    tags: ["花絮", "删减", "幕后"],
  },
  {
    id: "n9",
    title: "剧评：一场关于“代价”的叙事，而不是关于“胜利”",
    category: "深度解析",
    date: "2025-10-04",
    author: "剧评人 · 苏禾",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20an%20empty%20town%20square%20at%20dawn%20with%20long%20shadows%20and%20soft%20amber%20light%2C%20melancholic%20and%20epic%20drama%20mood%20widescreen&width=800&height=450&seq=news-n9-v1&orientation=landscape",
    summary:
      "大结局没有给你想要的爽感，它给了你更难得的东西：诚实。这是一部关于代价的剧，而不是关于胜利的剧。",
    content: [
      "看完整部《美国禁忌4》，你可能会发现，它从头到尾都没有真正“赢”过。",
      "每一次接近真相，都需要有人付出代价；每揭开一层，都有人失去一部分自己。这不是叙事的缺陷，而是这部作品的核心主张。",
      "大结局的黎明广场长镜头，与开篇的雨夜形成了精确的镜像。同样是那个地方，光照不同了，但人也不同了。",
      "它最后把选择权交回给了艾琳——不是告诉她该怎么选，而是让她自己决定要成为什么样的人。这种诚实，比任何胜利都更有力量。",
    ],
    tags: ["剧评", "大结局", "主题"],
  },
  {
    id: "n10",
    title: "官方发布最终季角色海报，八位主创同框引发回忆杀",
    category: "官方动态",
    date: "2025-08-20",
    author: "本站编译",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20eight%20character%20posters%20arranged%20on%20a%20dark%20wall%20with%20dramatic%20spotlights%2C%20deep%20blue%20and%20amber%20tones%2C%20premiere%20promo%20mood%20widescreen&width=800&height=450&seq=news-n10-v1&orientation=landscape",
    summary:
      "官方一次性发布最终季全部八位角色的个人海报，统一的冷蓝与暖橙配色，被剧迷称为“用四年调出的同一种光”。",
    content: [
      "这套最终季角色海报延续了全剧一贯的视觉语言：冷蓝的底色、暖橙的边缘光，以及几乎没有笑容的脸。",
      "八张海报拼在一起后，会形成一条从暗到亮的渐变，官方也借此暗示了最终季“走向黎明”的整体基调。",
      "剧迷在评论区注意到一个细节：艾琳的海报背景正是开篇那扇旧宅的门，与第二季首集形成了呼应。",
      "官方表示，这套海报会随最终季播出陆续解锁动态版本。",
    ],
    tags: ["官方动态", "海报", "视觉"],
  },
  {
    id: "n11",
    title: "人物关系梳理：一张图看懂四季里谁在保护谁",
    category: "深度解析",
    date: "2025-09-28",
    author: "本站整理",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20complex%20character%20relationship%20map%20with%20cards%20and%20lines%20on%20a%20dark%20board%2C%20amber%20pin%20lights%20and%20blue%20background%2C%20analytical%20mood%20widescreen&width=800&height=450&seq=news-n11-v1&orientation=landscape",
    summary:
      "从第一季到最终季，几乎所有关键抉择都围绕同一个问题：你在保护谁，又在欺骗谁。",
    content: [
      "如果说《美国禁忌4》有一条贯穿四季的暗线，那一定是“保护”。",
      "大卫保护艾琳，代价是继续背负谎言；艾琳保护哥哥的记忆，代价是不断压缩自己的判断；维多利亚保护秩序，代价是把所有人都变成了筹码。",
      "而最动人的一组关系，反而来自卡尔与苏菲这样的小人物——他们保护的是“说出来”的那一点点勇气。",
      "理解了这张关系网，就会明白为什么这部剧中没有纯粹的好人与坏人，只有一个个选择了代价的普通人。",
    ],
    tags: ["人物关系", "梳理", "深度"],
  },
  {
    id: "n12",
    title: "采访摄影指导：我们如何用光讲述“秘密”",
    category: "采访",
    date: "2025-07-30",
    author: "本站特约",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20camera%20rig%20and%20lighting%20setup%20on%20a%20dark%20set%20with%20warm%20amber%20key%20light%2C%20deep%20blue%20background%2C%20cinematography%20documentary%20mood%20widescreen&width=800&height=450&seq=news-n12-v1&orientation=landscape",
    summary:
      "在最终季播出前，摄影指导分享了全剧“冷蓝底 + 暖橙边”的视觉方案，以及它如何服务“秘密”这一主题。",
    content: [
      "“我们从来不把光打满，”摄影指导说，“因为秘密总是藏在没有光的地方。”",
      "全剧的视觉基调被概括为“冷蓝底、暖橙边”：冷蓝代表公共的、表面的世界，暖橙则代表私人的、真实的情感。",
      "这种用光方式在角色特写中尤其明显——当人物说谎时，暖光会被压到最低；当他们终于坦白，暖光才第一次打满整张脸。",
      "他笑称，很多观众不会注意到这些细节，但正是这些细节，才让这部剧“越看越有味道”。",
    ],
    tags: ["采访", "摄影", "视觉"],
  },
];